import { render, staticRenderFns } from "./DrawSample.vue?vue&type=template&id=32bab13a&scoped=true&lang=pug&"
import script from "./DrawSample.vue?vue&type=script&lang=ts&"
export * from "./DrawSample.vue?vue&type=script&lang=ts&"
import style0 from "./DrawSample.vue?vue&type=style&index=0&id=32bab13a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bab13a",
  null
  
)

export default component.exports